import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentPropsWithoutRef<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "redait-toast group toast",
          description: "redait-toast__description",
          actionButton: "redait-toast__action",
          cancelButton: "redait-toast__cancel",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
